
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/register",
      function () {
        return require("private-next-pages/[lang]/register.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/register"])
      });
    }
  